<script>
  export let header
  export let pages
  export let urlBase = './'
  export let activePath = null
  export let vertical = false
</script>

<style type="text/less">
  nav {
    width: 100%;
  }

  // ── Horizontal mode (legacy) ──────────────────────────────────────
  .horizontal .subnav {
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    list-style: none;
    padding: 0;
    margin: 0;
    border: solid 1px var(--col-gray-80);
    background: var(--col-gray-98);
    border-radius: var(--border-radius);
  }

  .horizontal .subnav-item {
    display: inline;

    a {
      display: inline-block;
      text-decoration: none;
      padding: var(--spacing-sm);
    }

    &.active a {
      text-decoration: underline;
    }
  }

  // ── Vertical mode (account sidebar nav) ──────────────────────────
  .vertical .subnav {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .vertical .subnav-item {
    display: block;

    a {
      display: flex;
      align-items: center;
      gap: var(--spacing-sm);
      padding: var(--spacing-sm) var(--spacing-sm);
      text-decoration: none;
      border-radius: var(--border-radius);
      color: var(--col-text);
      font-size: var(--font-size-sm);
      transition: background 0.1s ease;

      &:link, &:visited {
        color: var(--col-text);
      }

      &:hover {
        background: var(--col-gray-90);
        text-decoration: none;
      }

      .nav-icon {
        width: 1.1em;
        height: 1.1em;
        flex-shrink: 0;
        opacity: 0.55;
      }
    }

    &.active a {
      background: var(--col-accent-2);
      color: var(--col-gray-100);
      font-weight: 600;

      &:link, &:visited {
        color: var(--col-gray-100);
      }

      &:hover {
        background: var(--col-accent-2-l);
      }

      .nav-icon {
        opacity: 1;
      }
    }
  }

  .subnav-header {
    padding: var(--spacing-xs) var(--spacing-sm);
    font-size: var(--font-size-xs);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--col-gray-50);
    font-weight: 600;
  }
</style>

{#if pages.length}
  <nav class={vertical ? 'vertical' : 'horizontal'}>
    {#if header}
      <div class="subnav-header">{header}</div>
    {/if}
    <ul class="subnav">
      {#each pages as page}
        <li
          class="subnav-item"
          class:active={page.url_path === activePath}>
          <a href={urlBase + page.url_path}>
            {#if page.icon}
              <svg class="icon nav-icon"><use href="/icons.svg#{page.icon}"></use></svg>
            {/if}
            {page.name}
          </a>
        </li>
      {/each}
    </ul>
  </nav>
{/if}
